import AttributeTag from './AttributeTag';

export default AttributeTag;